// Module
var code = `<div class="alert">
  <span>
    <strong>DISCLAIMER:</strong> This form can be used to push failed end of day job.
  </span>
</div>

<h2 class="section-header">Please confirm the following:</h2>
<form name="form">
  <table class="table">
    <tbody>
    <tr>
      <td>Branch:</td>
      <td>
        <select
          ng-model="\$ctrl.branch"
          ng-options="branch as branch.name | prettyEnum for branch in \$ctrl.branches | orderBy:'name'"
          required>
        </select>
      </td>
    </tr>
    <tr>
      <td>Batch Job Type:</td>
      <td>
        <select
          ng-model="\$ctrl.selectedJobType"
          ng-options="jobType | prettyEnum for jobType in \$ctrl.batchJobTypes"
          required>
        </select>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="pull-right">
    <button
      type="submit"
      class=" btn btn-success"
      ng-disabled="form.\$invalid"
      ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/push-failed-eod/push-failed-eod.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;